import { Field, reduxForm } from 'redux-form';
import { Button, Input } from '@components';

const validate = values => {
  const errors = {};
  if (!values.email) {
    errors.email = 'Campo obrigatório! ';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'E-mail inválido! ';
  }
  return errors;
};

const renderField = ({
  input,
  label,
  type,
  meta: { touched, error, warning },
}) => (
  <>
    <Input {...input} caption={label} type={type} />
    {touched &&
      ((error && <span className="text-sm text-red-500">{error}</span>) ||
        (warning && <span className="text-sm text-red-500">{warning}</span>))}
  </>
);

const ForgotValidation = ({
  handleSubmit,
  submitFunction,
  submitting,
  invalid,
  load_mutation,
  submitSucceeded
}) => {
  return (
    <form className="space-y-8" onSubmit={handleSubmit(submitFunction)}>
      <Field
        name="email"
        type="email"
        autoComplete="email"
        component={renderField}
        label="E-mail"
      />
      <Button
        type="submit"
        fullWidth
        variant="primary"
        disabled={invalid || submitSucceeded}
        isLoading={submitting || load_mutation}
      >
        Enviar e-mail
      </Button>
    </form>
  );
};

export default reduxForm({
  form: 'forgotValidation',
  validate,
})(ForgotValidation);
